import { Watch, UnsubscribeEvent, SubscribeEvent } from "@/models"
import {
    GET_USER_ID,
    HAS_$SOCKET,
    GET_$SOCKET,
    GET_JWT_TOKEN,
    GET_SELECTED_VENUE_ID,
    GET_SELECTED_MARKET_ID,
    GET_SELECTED_SMART_BOX_MAC_ADDRESS_LIST,
} from "@/store/types/getters"
import { isFunction } from "lodash"
import store from "@/store"
import { isValidUserId, isNotEmpty } from "@/utils/validate"
import {
    fetchCountryList,
    fetchCompanyList,
    fetchGatewayVersionList,
    fetchSblDriveVersionList,
    fetchMarketList,
    fetchSmartBoxList,
    fetchVenueList,
    fetchOperationLogList,
} from "@/store/types/actions"
import {
    CountryModuleNamespace,
    CompanyModuleNamespace,
    VersionModuleNamespace,
    SmartBoxModuleNamespace,
    MarketModuleNamespace,
    VenueModuleNamespace,
} from "@/consts"

const watchers: Watch[] = [
    {
        getter: (_state, getters) => getters[GET_USER_ID],
        cb: async (value, oldValue) => {
            if (!store.getters[HAS_$SOCKET]) {
                return
            }

            if (isValidUserId(oldValue)) {
                const ubsubscribeEvent: UnsubscribeEvent = {
                    type: "unsubscribe",
                    userId: oldValue,
                }
                if (isFunction(store.getters[GET_$SOCKET].sendObj)) {
                    store.getters[GET_$SOCKET].sendObj(ubsubscribeEvent)
                }
            }

            if (isValidUserId(value)) {
                const subscribeEvent: SubscribeEvent = {
                    type: "subscribe",
                    userId: value,
                }
                if (isFunction(store.getters[GET_$SOCKET].sendObj)) {
                    store.getters[GET_$SOCKET].sendObj(subscribeEvent)
                }
            }
        },
        options: {
            deep: false,
            immediate: false,
        },
    },
    {
        getter: (_state, getters) => getters[GET_JWT_TOKEN],
        cb: async value => {
            if (isNotEmpty(value)) {
                store.dispatch(CompanyModuleNamespace + "/" + fetchCompanyList)
                store.dispatch(CountryModuleNamespace + "/" + fetchCountryList)
                store.dispatch(
                    VersionModuleNamespace + "/" + fetchGatewayVersionList
                )
                store.dispatch(
                    VersionModuleNamespace + "/" + fetchSblDriveVersionList
                )

                store.dispatch(MarketModuleNamespace + "/" + fetchMarketList)
            }
        },
        options: {
            deep: false,
            immediate: false,
        },
    },
    {
        getter: (_state, getters) => [
            getters[GET_JWT_TOKEN],
            getters[VenueModuleNamespace + "/" + GET_SELECTED_VENUE_ID],
        ],
        cb: async ([jwtToken, venueId]) => {
            if (
                isNotEmpty(jwtToken) &&
                isNotEmpty(venueId) &&
                isNotEmpty(store)
            ) {
                store.dispatch(
                    SmartBoxModuleNamespace + "/" + fetchSmartBoxList
                )
            }
        },
        options: {
            deep: false,
            immediate: false,
        },
    },
    {
        getter: (_state, getters) => [
            getters[GET_JWT_TOKEN],
            getters[MarketModuleNamespace + "/" + GET_SELECTED_MARKET_ID],
        ],
        cb: async ([jwtToken, venueId]) => {
            if (
                isNotEmpty(jwtToken) &&
                isNotEmpty(venueId) &&
                isNotEmpty(store)
            ) {
                store.dispatch(VenueModuleNamespace + "/" + fetchVenueList)
            }
        },
        options: {
            deep: false,
            immediate: false,
        },
    },
    {
        getter: (_state, getters) =>
            getters[
                SmartBoxModuleNamespace +
                    "/" +
                    GET_SELECTED_SMART_BOX_MAC_ADDRESS_LIST
            ],
        cb: async () => {
            store.dispatch(
                SmartBoxModuleNamespace + "/" + fetchOperationLogList
            )
        },
        options: {
            deep: false,
            immediate: false,
        },
    },
]

export default watchers
